/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IConnectionValidation {
        result: string;
        message: string;
        data: Object;
        params: string[];
    }
}